/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState, useContext } from 'react';
import { ATCONSTANTS as ATC, communicateOptions } from 'appconstants';
import EmailGenerator from 'components/EmailGenerator/EmailGenerator';
import { getReason } from 'actions/common';
import bindLogger from 'helpers/BindLogger';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AppContext } from '@ctsu/loader';
import _ from 'lodash';
import { FormRow, FormRadio } from 'components/CustomComponents/FormRow';
import { checkEmailType } from 'components/EmailGenerator/CommunicateUtils';
import { dateFormatter } from 'helpers';

function CommunicationMethod(props) {
  const {
    cancelEdit,
    saveCommunicationHanlder,
    keyValue,
    dbId,
    cancelCommunicationHanlder,
    controller,
    appliedFilters,
    showReason,
    tagName,
    orgType,
    mode,
    emailId,
    reasons,
    sendDate,
    additionalDetails,
    CopyPasteFields,
    fetchReason
  } = props;

  const context = useContext(AppContext);
  const [selectedComOption, setSelectedComOption] = useState(null);
  const [errors, setErrors] = useState({});
  const [selectedReason, setSelectedReason] = useState(null);
  const { session } = context;
  const [commentsState, setCommentState] = useState('');

  const getPhoneComments = () => {
    let phoneComments = `Called NAME on ${dateFormatter(new Date(), 'dd-MMM-yyyy hh:mm')} - ${session.username}`;
    if (orgType === 'PACKET_SCREENS') {
      const { otherContact, contact, contactCtepId } = additionalDetails;
      let replaceText = '';
      if (otherContact && otherContact.trim() !== '') {
        replaceText = otherContact;
      } else {
        replaceText = contact ? `${contact} (${contactCtepId})` : 'NAME';
      }
      phoneComments = phoneComments.replace('NAME', replaceText);
    }
    return phoneComments;
  };

  const handleComOptionChange = (e) => {
    setSelectedComOption(e.target.value);
    if (showReason && e.target.value === 'None') {
      setCommentState('');
      setSelectedReason(null);
    }
    if (!showReason && e.target.value === 'None') {
      cancelCommunicationHanlder();
    }
    if (e.target.value === 'Phone') {
      const phoneComments = getPhoneComments();
      setCommentState(phoneComments);
    }
  };

  useEffect(() => {
    if (mode) setSelectedComOption('Email');
  }, [mode]);

  useEffect(() => {
    if (showReason) {
      bindLogger(fetchReason, context)(orgType === 'PACKET_SCREENS' ? 'PP' : 'CAP');
    }
  }, [showReason, fetchReason, context, orgType]);

  const handleChange = (e) => {
    setSelectedReason(e);
  };

  const renderPhoneOrNone = () => {
    if (selectedComOption === 'Phone' || selectedComOption === 'None') {
      return (
        <FormRow
          dataId={`${ATC.CAPID}COMMENT${ATC.TEXTAREA}`}
          value={commentsState}
          label="Comment"
          type="textarea"
          name="comment"
          rows="3"
          cols="58"
          error={errors.comment}
          onChange={(e) => setCommentState(e.target.value)}
          required={selectedComOption === 'Phone'}
        />
      );
    }
    return null;
  };

  const checkFormAndSubmit = () => {
    let flag = true;
    let errorData = _.clone(errors);
    if (selectedComOption === 'Phone' && _.isEmpty(commentsState)) {
      errorData = {
        ...errorData,
        comment: 'Comment is mandatory for phone.'
      };
      flag = false;
    }
    if (showReason && selectedComOption !== 'None' && _.isEmpty(selectedReason)) {
      errorData = {
        ...errorData,
        reason: 'Follow up reason is mandatory.'
      };
      flag = false;
    }
    setErrors(errorData);
    return flag;
  };
  return (
    <div className="form-layout-wrapper">
      <div className="form-layout-header">
        <div className="form-layout-title">{mode ? 'View Email' : checkEmailType(showReason)}</div>
      </div>
      <div className="form-layout-body">
        <div>
          <span className="form-layout-required">* required field.</span>
        </div>
        <ul>
          {selectedComOption !== 'None' && showReason && (
            <FormRow
              dataId={`${ATC.APP}RC_STAGE${ATC.SELECT}`}
              value={selectedReason}
              label="Select a follow-up reason:"
              type="select"
              name="reason"
              error={errors.reason}
              onChange={(e) => {
                handleChange(e);
              }}
              options={reasons}
              required
              readOnly={mode}
            />
          )}
          {!mode && (
            <FormRadio
              dataId={`${ATC.APP}OPTIONS${ATC.RADIO}`}
              labelId="communicateOptions"
              selectedVal={selectedComOption}
              onChange={handleComOptionChange}
              options={communicateOptions}
              label="Select a communication method:"
            />
          )}
          {selectedComOption === 'Email' && (
            <EmailGenerator
              cancelCommunicationHanlder={cancelCommunicationHanlder}
              tagName={tagName}
              orgType={orgType}
              controller={controller}
              appliedFilters={appliedFilters}
              keyValue={keyValue}
              dbId={dbId}
              errors={errors}
              setErrors={setErrors}
              cancelEdit={cancelEdit}
              mode={mode}
              showReason={showReason}
              emailId={emailId}
              reason={selectedReason}
              setReason={setSelectedReason}
              sendDate={sendDate}
              CopyPasteFields={CopyPasteFields}
            />
          )}
          {renderPhoneOrNone()}
        </ul>
      </div>
      {selectedComOption && selectedComOption !== 'Email' && (
        <div className="form-layout-footer">
          <div className="form-layout-actions align-center">
            <button
              type="button"
              data-id={`${ATC.APP}COMMUNICATE_SAVE${ATC.BUTTON}`}
              className="btn turquoise mx-1"
              title="Save"
              onClick={() => {
                if (checkFormAndSubmit()) {
                  saveCommunicationHanlder(commentsState, selectedComOption, selectedReason, showReason, setErrors);
                }
              }}
            >
              Save
            </button>
            <button
              data-id={`${ATC.APP}COMMUNICATION_CANCEL${ATC.BUTTON}`}
              type="button"
              className="btn close mx-1"
              title="Cancel"
              onClick={() => cancelCommunicationHanlder()}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  reasons: state.email.reasons
});

const withConnectState = connect(mapStateToProps, (dispatch) => bindActionCreators(
  {
    fetchReason: getReason
  },
  dispatch
));

export default withConnectState(CommunicationMethod);
